import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { AuthenticationService } from "../../../core/services/auth.service";
import { AuthfakeauthenticationService } from "../../../core/services/authfake.service";

import { ActivatedRoute, Router } from "@angular/router";
import { first } from "rxjs/operators";

import { environment } from "../../../../environments/environment";
import { CommonService } from "src/app/shared/services/common.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  error = "";
  returnUrl: string;

  // set the currenr year
  year: number = new Date().getFullYear();
  isChecked: boolean = false;
  @ViewChild("phoneInput") phoneInput: ElementRef | undefined;
  @ViewChild("passwordInput") passwordInput: ElementRef | undefined;
  // tslint:disable-next-line: max-line-length
  constructor(
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public authenticationService: AuthenticationService,
    public authFackservice: AuthfakeauthenticationService
  ) {
    const storedValue = localStorage.getItem("rememberMe");
    if (storedValue) {
      this.isChecked = JSON.parse(storedValue);
      if (this.isChecked) {
        const storedCredentials = localStorage.getItem("credentials");
        if (storedCredentials) {
          const { phone, password } = JSON.parse(storedCredentials);
          if (this.phoneInput && this.passwordInput) {
            this.phoneInput.nativeElement.value = phone;
            this.passwordInput.nativeElement.value = password;
          }
        }
      }
    }
  }

  ngOnInit() {
    document.body.removeAttribute("data-layout");
    document.body.classList.add("auth-body-bg");

    this.loginForm = this.formBuilder.group({
      phone: ["", [Validators.required]],
      password: ["", [Validators.required]],
      rememberMe: [false],
    });

    // reset login status
    // this.authenticationService.logout();
    // get return url from route parameters or default to '/'
    // tslint:disable-next-line: no-string-literal
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }
  onCheckboxChange(event: Event) {
    this.isChecked = (event.target as HTMLInputElement).checked;
    localStorage.setItem("rememberMe", JSON.stringify(this.isChecked));

    if (this.isChecked) {
      const phone = this.f.phone.value;
      const password = this.f.password.value;
      localStorage.setItem("credentials", JSON.stringify({ phone, password }));
    } else {
      localStorage.removeItem("credentials");
    }
  }
  /**
   * Form submit
   */
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    } else {
      if (environment.defaultauth === "firebase") {
        this.authenticationService
          .login(this.f.phone.value, this.f.password.value)
          .then((res: any) => {
            this.router.navigate(["/"]);
          })
          .catch((error) => {
            this.error = error ? error : "";
          });
      } else {
        const data = this.loginForm.value;
        this.authFackservice
          .login(this.f.phone.value, this.f.password.value)
          .pipe(first())
          .subscribe(
            (data) => {
              switch (data?.data?.role) {
                case "admin":
                  this.router.navigate(["/"]);
                  break;
                case "partner_operation":
                case "iris_operation":
                  this.router.navigate(["/MB-dashboard"]);
                  break;
                case "operation":
                  this.router.navigate(["/invoice-manager"]);
                  break;
                case "iris_operation":
                case "iris_partner":
                case "branch_operation":
                  this.router.navigate(["/branch"]);
                  break;
                case "switchboard":
                  this.router.navigate(["/search-orders"]);
                  break;
                case "customer service":
                  this.router.navigate(["/orders-manager"]);
                  break;
                case "delivery":
                  if (data?.data?.full_name?.includes("TMT_CSKH")) {
                    this.router.navigate(["/VTP-Pending"]);
                  } else {
                    this.router.navigate(["/GHN-Pending"]);
                  }
                  break;
                default:
                  this.router.navigate(["/account/workspace"]);
                  break;
              }
              this.commonService.flagLogin = true;
            },
            (error) => {
              this.error = error ? error : "";
            }
          );
      }
    }
  }
  showPassword: boolean = false;

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      setTimeout(() => {
        this.showPassword = false;
      }, 2000);
    }
  }
}
